/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum CssUnitEnum {
    SVH = 'SVH',
    PERC = 'PERC',
    PX = 'PX',
    REM = 'REM',
    VH = 'VH',
}